import Controller from '../../utilities/manage-products-base-controller';

export default class extends Controller {
  renderProduct(product) {
    return `
      <li class='mb-4 border-b cursor-pointer relative'
          id='manage-product-${product.id}'
          data-id=${product.id}
          data-action='click->layout-filters--manage-products#handleProductDisplay'>
        <span class='text-md'>${product.totalAvailableInventories} ${product.name}</span>
        <ion-icon class='absolute layout__manage-icon' name='chevron-forward-outline'></ion-icon>
        <br/>
        <span class='text-xs text-gray-500'>${product.totalPlacedInventories} Active Positions</span>
      </li>
    `;
  }
}
